/**
 * LogLevel is an enum of all log levels supported by Logger.
 *
 * FIXME: Make sure we tell people when to use what and when.
 */
enum LogLevel {
  TRACE = 'trace',
  DEBUG = 'debug',
  INFO = 'info',
  WARN = 'warn',
  ERROR = 'error',
  SILENT = 'silent',
}

export { LogLevel };
